<template>

  <a-dropdown :trigger="['click']">
    <a class="ant-dropdown-link" @click.prevent style="color: teal; text-wrap: nowrap;">
      选项
      <huasky-icon icon="SettingOutlined" />
    </a>
    <template #overlay>
      <a-menu @click="onClick">
        <a-menu-item key="0" :disabled="!navigate.isEdit">
          <huasky-icon icon="SaveOutlined" />
          保存
        </a-menu-item>
        <a-menu-item key="1">
          <huasky-icon icon="CopyOutlined" />
          另存为
        </a-menu-item>
        <a-menu-item key="2" :disabled="!navigate.isEdit">
          <huasky-icon icon="ReloadOutlined" />
          编辑
        </a-menu-item>
        <a-menu-divider />
        <a-menu-item key="3" :disabled="!navigate.isEdit" danger>
          <huasky-icon icon="DeleteOutlined" />
          删除
        </a-menu-item>
      </a-menu>
    </template>
  </a-dropdown>

  <huasky-query-setting v-model:visible="settingPara.visible" :saveKey="key" :query="navigate" @submit="save" />
</template>
<script setup lang="ts">
import { removePageSetting, renamePageSetting, savePageSetting } from '@src/scripts/api/setting'
import { saveAppData } from '@src/scripts/system'
import { reactive, ref } from 'vue'

const props = withDefaults(defineProps<{
  navigate: PageNavigate<OrderQuery>,
  queryType: string
}>(), {

})
const emits = defineEmits(['onClick'])

const settingPara = reactive({
  name: '',
  sort: 0,
  visible: false
})

let key = ref('')
const onClick = async (event: any) => {
  if (event.key === '0') {
    const setting = generateSetting()
    const { data } = await savePageSetting(setting)
    $app.pageSettings.replace(data, a => a.id === data.id)
    saveAppData()
    $util.message.success('保存成功')
    emits('onClick', event.key)
  }
  else if (event.key === '1') {
    key.value = event.key
    settingPara.visible = true
  } else if (event.key === '2') {
    key.value = event.key
    settingPara.visible = true
  } else if (event.key === '3') {
    $util.modal.confirm({
      title: '提示',
      content: '此操作不可恢复，确定删除吗？',
      async onOk() {
        const setting = generateSetting()
        await removePageSetting(setting.id as string)
        $app.pageSettings.remove(props.navigate.setting as PageSetting)
        saveAppData()
        $util.message.success('删除成功')
        emits('onClick', event.key)
      }
    })
  }
}

const save = async (para: { name: string, sort: number }) => {
  const setting = generateSetting()
    setting.name = para.name
    setting.sort = para.sort
  if (key.value === '1') {
    setting.id = undefined
    const { data } = await savePageSetting(setting)
    $app.pageSettings.push(data)
  } else if (key.value === '2') {
    const { data } = await renamePageSetting(setting)
    $app.pageSettings.replace(data, a => a.id === data.id)
  }
  saveAppData()
  $util.message.success('保存成功')
  emits('onClick', key.value)
}

const generateSetting = () => {
  const query = $util.clone(props.navigate.data)
  query.pageIndex = 0
  query.searchKey = ''
  const setting = props.navigate.setting ?? {
    ownerId: $app.staff?.id ?? $app.store?.id,
    type: props.queryType,
    name: '',
    sort: 1,
    content: ''
  } as PageSetting
  const cloneSetting = $util.clone(setting)
  cloneSetting.content = JSON.stringify(query)
  return cloneSetting
}

</script>
<style lang="scss" scoped>
</style>